export default __webpack_public_path__ + "static/media/logo-sm.442176fb.svg";